<app-expandable-section-box
  [title]="'External Links'"
  [iconClass]="'icon-external-link'"
  [isExpandedByDefault]="isExpandedByDefault"
  [isExpandable]="isExpandable"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="py-1" *ngFor="let item of externalLinksControl.value">
      <div class="flex flex-row items-center justify-between">
        <button
          class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-3300"
          data-testid="addBtn"
          title="Add to body"
          (click)="onAddToBody(item)"
        >
          <i class="icon icon-plus-circle"></i>
        </button>
        <a class="w-10/12 px-2" [href]="item.url" target="_blank">
          {{ item.text }}
        </a>
        <button
          class="px-2 text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-3300"
          data-testid="editBtn"
          title="edit"
          (click)="onEditExternalLink(item)"
        >
          <i class="icon icon-edit"></i>
        </button>
        <button
          class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
          data-testid="removeBtn"
          title="Remove"
          (click)="onRemove(item)"
        >
          <i class="icon icon-minus-circle"></i>
        </button>
      </div>
    </div>

    <form
      *ngIf="isLinkFormVisible"
      [formGroup]="externalLinkForm"
      (submit)="addExternalLink()"
    >
      <mat-form-field appearance="outline" class="w-full">
        <input matInput placeholder="Link text title" formControlName="text" />
        <mat-error class="pt-2">Please enter some link text</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-full">
        <input
          matInput
          type="url"
          placeholder="Link URL"
          formControlName="url"
        />
        <mat-error
          *ngIf="externalLinkForm.controls.url.hasError('required')"
          class="pt-2"
        >
          Please enter a link URL
        </mat-error>
        <mat-error
          *ngIf="externalLinkForm.controls.url.hasError('pattern')"
          class="pt-2"
        >
          Please enter a valid URL
        </mat-error>
      </mat-form-field>
      <div class="flex w-full py-4 space-x-3">
        <button
          mat-flat-button
          type="submit"
          *ngIf="!isEditMode"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Add link
        </button>
        <button
          mat-flat-button
          type="button"
          *ngIf="isEditMode"
          (click)="editExternalLink()"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Modify
        </button>
        <button
          mat-flat-button
          type="reset"
          (click)="toggleLinkForm()"
          class="w-full h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
        >
          Cancel
        </button>
      </div>
    </form>
    <button
      mat-flat-button
      type="button"
      (click)="initExternalLinkForm()"
      *ngIf="!isLinkFormVisible"
      class="h-8 text-xs font-semibold bg-white border border-solid border-project-100 text-project-500"
    >
      Add new link
    </button>
  </div>
  <div
    notExpandedContent
    *ngIf="externalLinksControl.value.length"
    class="py-2"
  >
    <div
      class="text-xs font-bold underline cursor-pointer text-project-500"
      *ngFor="let item of externalLinksControl.value"
    >
      <a [href]="item.url" target="_blank" class="text-current">{{
        item.text
      }}</a>
    </div>
  </div>
</app-expandable-section-box>
